import * as React from "react";
import PropTypes from "prop-types";
import Spinner from "react-spinkit";
import HotTable from "./utils/hot-table";
import moment from "moment";
import PPIProject from "./investments/project-container.js";
import RevenueForm from "./revenues/form-container";
import ExpenseForm from "./expenses/form-container";
import InvestmentThemeForm from "./investments/theme-form-container";
import InvestmentThemeProjectForm from "./investments/project-form-container";
import InvestmentThemeProjectGrantForm from "./investments/grants/form-container";
import Induced from "./investments/induced-container";
import Popup from "./utils/popup";
import PpiActions from "./ppi-actions";
import ManageYearForm from "./manage-year-form-container";

export default class PPIDetailComponent extends React.Component {
  render() {
    var isProject =
      this.props.action &&
      (this.props.action.indexOf("alter_project") !== -1 ||
        this.props.action.indexOf("grant") !== -1);

    return (
      <div className="ppi-container">
        <div
          className={`global-loader ${
            this.props.globalLoading ? "loading" : ""
          }`}
        >
          <Spinner fadeIn="none" name="cube-grid" color="orange" />
          {/*Mise-à-jour*/}
        </div>
        <PpiActions
          pageTitle={this.props.pageTitle}
          selectedPriorities={this.props.selectedPriorities}
          consulted={this.props.consulted}
          priorities={this.props.priorities}
          enablePreviousYear={
            this.props.ppi.years[0].year < parseInt(moment().format("YYYY"))
          }
          previousYear={this.props.previousYear}
          onCustomAction={this.props.onCustomAction}
          onTogglePreviousYear={this.props.onTogglePreviousYear}
          isProject={isProject}
          project={this.props.actionData ? this.props.actionData.project : null}
          theme={this.props.actionData ? this.props.actionData.theme : null}
          subtheme={
            this.props.actionData ? this.props.actionData.subtheme : null
          }
          onBack={this.props.onHidePopup}
          onPrioritiesChange={this.props.onPrioritiesChange}
          onToggleAsResponsible={this.props.onToggleAsResponsible}
          setSelectedPriorities={this.props.actions.setSelectedPriorities}
        />
        {this.props.action &&
        (this.props.action.indexOf("alter_project") !== -1 ||
          this.props.action.indexOf("grant") !== -1) ? (
          <PPIProject
            consulted={this.props.consulted}
            current_year={this.props.current_year}
            project={this.props.actionData.project}
            theme={this.props.actionData.theme}
            subtheme={this.props.actionData.subtheme}
            grants={this.props.grants}
            ppi={this.props.ppi}
            onCustomAction={this.props.onCustomAction}
            onProjectUpdated={this.props.onProjectUpdated}
          />
        ) : null}
        <div
          className="ppi-table-container"
          style={{
            display:
              this.props.action &&
              (this.props.action.indexOf("alter_project") !== -1 ||
                this.props.action.indexOf("grant") !== -1)
                ? "none"
                : "block",
          }}
        >
          <div
            style={{
              backgroundColor: "#3d3c3f",
              color: "white",
              fontSize: "18px",
              padding: "1px",
              zIndex: 102,
              position: "absolute"
            }}
          >
            PPI Général basé sur le scénario
            <b style={{ color: "#15b2bf", padding: "5px" }}>
              <span style={{ color: "#fff", fontSize: "12px" }}>{"« "}</span>
              {this.props.scenario.description}
              <span style={{ color: "#fff", fontSize: "12px" }}>{" »"}</span>
            </b>
          </div>
          <HotTable
            consulted={this.props.consulted}
            root="main"
            title=""
            // title={
            //   "PPI Général basé sur le scénario" +
            //   this.props.scenario.description
            // }
            currentLocalAuthority={this.props.currentLocalAuthority}
            currentUser={this.props.currentUser}
            asResponsible={this.props.asResponsible}
            actions={this.props.actions}
            headers={this.props.ppi.years
              .filter((y) => y.year >= this.props.current_year)
              .map((year) => year.year)}
            data={this.props.data}
            ppi={this.props.ppi}
            projectsData={this.props.projectsData}
            current_year={this.props.current_year}
            priorities={this.props.priorities}
            shownThemes={this.props.shownThemes}
            tableDefinition={this.props.tableDefinition}
            onCustomAction={this.props.onCustomAction}
            onThemeToggle={this.props.onThemeToggle}
            onToggleGrantTheme={this.props.onToggleGrantTheme}
            onProjectsDataBuild={this.props.onProjectsDataBuild}
            onProjectToggle={this.props.onProjectToggle}
            onToggleGrants={this.props.onToggleGrants}
            onChange={this.props.onChange}
            previousYear={this.props.previousYear}
            currentUserType = {this.props.currentUserType}
          />
        </div>
        {this.props.action && !(this.props.action == "alter_project") ? (
          <Popup
            onHide={this.props.onHidePopup}
            title={this._buildPopupTitle()}
          >
            {this._buildPopupContent()}
          </Popup>
        ) : null}
      </div>
    );
  }

  _buildPopupTitle() {
    var title = null;
    switch (this.props.action) {
      case "new_revenue":
        title = "Créer une recette";
        break;
      case "alter_revenue":
        title = "Modifier la recette";
        break;
      case "destroy_revenue":
        title = "Supprimer la recette";
        break;
      case "new_expense":
        title = "Créer une dépense";
        break;
      case "alter_expense":
        title = "Modifier la dépense";
        break;
      case "destroy_expense":
        title = "Supprimer la dépense";
        break;
      case "new_investment_theme":
        title = "Créer un thème";
        break;
      case "alter_investment_theme":
        title = "Modifier un thème";
        break;
      case "destroy_investment_theme":
        title = "Supprimer un thème";
        break;
      case "add_sub_investment_theme":
        title = "Créer une sous-thématique";
        break;
      case "new_project":
        title = "Créer un projet";
        break;
      case "popup_alter_project":
        title = "Configurer le projet";
        break;
      case "destroy_project":
        title = "Supprimer un projet";
        break;
      case "new_grant":
        title = "Créer une subvention";
        break;
      case "alter_grant":
        title = "Modifier une subvention";
        break;
      case "destroy_grant":
        title = "Supprimer une subvention";
        break;
      case "toggle_grant":
        title = this.props.actionData.grant.awarded
          ? "Annuler une subvention"
          : "Octroyer la subvention";
      case "project_induced_grant":
        title = "Charges & Recettes induites";
        break;
      case "add_year":
        title = "Ajouter une année";
        break;
      case "delete_last_year":
        title = "Supprimer la dernière année";
        break;
    }
    return title;
  }

  _buildPopupContent() {
    var content = null;
    switch (this.props.action) {
      case "new_revenue":
      case "alter_revenue":
      case "destroy_revenue":
        content = (
          <RevenueForm
            actions={this.props.actions}
            ppi={this.props.ppi}
            revenue={this.props.actionData}
            delete={this.props.action == "destroy_revenue"}
            onCreated={this.props.onRevenueCreated}
            onUpdated={this.props.onRevenueUpdated}
            onDeleted={this.props.onRevenueDeleted}
          />
        );
        break;
      case "new_expense":
      case "alter_expense":
      case "destroy_expense":
        content = (
          <ExpenseForm
            actions={this.props.actions}
            ppi={this.props.ppi}
            expense={this.props.actionData}
            delete={this.props.action == "destroy_expense"}
            onCreated={this.props.onExpenseCreated}
            onUpdated={this.props.onExpenseUpdated}
            onDeleted={this.props.onExpenseDeleted}
          />
        );
        break;
      case "new_investment_theme":
      case "alter_investment_theme":
      case "destroy_investment_theme":
      case "add_sub_investment_theme":
        content = (
          <InvestmentThemeForm
            actions={this.props.actions}
            ppi={this.props.ppi}
            users={this.props.users}
            theme={
              this.props.action !== "add_sub_investment_theme"
                ? this.props.actionData
                : null
            }
            parentTheme={
              this.props.action == "add_sub_investment_theme"
                ? this.props.actionData
                : null
            }
            delete={this.props.action == "destroy_investment_theme"}
            onCreated={this.props.onThemeCreated}
            onUpdated={this.props.onThemeUpdated}
            onDeleted={this.props.onThemeDeleted}
          />
        );
        break;
      case "new_project":
      case "popup_alter_project":
      case "destroy_project":
        content = (
          <InvestmentThemeProjectForm
            actions={this.props.actions}
            ppi={this.props.ppi}
            project={this.props.actionData.project}
            theme={this.props.actionData.theme}
            subtheme={this.props.actionData.subtheme}
            delete={this.props.action == "destroy_project"}
            onCreated={this.props.onProjectCreated}
            onUpdated={this.props.onProjectUpdated}
            onDeleted={this.props.onProjectDeleted}
          />
        );
        break;
      case "new_grant":
      case "alter_grant":
      case "toggle_grant":
      case "destroy_grant":
      case "toggle_grant":
        content = (
          <InvestmentThemeProjectGrantForm
            actions={this.props.actions}
            ppi={this.props.ppi}
            grant={this.props.actionData.grant}
            grants={this.props.grants}
            project={this.props.actionData.project}
            awarded={this.props.actionData.awarded}
            delete={this.props.action == "destroy_grant"}
            toggle={this.props.action == "toggle_grant"}
            onCreated={this.props.onGrantCreated}
            onUpdated={this.props.onGrantUpdated}
            onDeleted={this.props.onGrantDeleted}
            onToggled={this.props.onGrantToggled}
          />
        );
        break;
      case "project_induced_grant":
        content = (
          <Induced
            actions={this.props.actions}
            ppi={this.props.ppi}
            project={this.props.actionData.project}
            onSave={this.props.onInducedsSaved}
          />
        );
        break;
      case "add_year":
      case "delete_last_year":
        content = (
          <ManageYearForm
            actions={this.props.actions}
            ppi={this.props.ppi}
            action={this.props.action == "add_year" ? "add" : "delete"}
            onYearAdded={this.props.onYearAdded}
            onLastYearDeleted={this.props.onLastYearDeleted}
          />
        );
        break;
    }
    return content;
  }
}

PPIDetailComponent.propTypes = {
  loading: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/ppi-detail-component.js